import {
  Box,
  Button,
  Card,
  CardContent,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";
import React, { useState, useEffect } from "react";
import ApartmentIcon from "@mui/icons-material/Apartment";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import ChevronLeftOutlinedIcon from "@mui/icons-material/ChevronLeftOutlined";
import API from "../../Utils/Interceptor/ApiMiddleware";
import { useNavigate, useParams } from "react-router-dom";
import AddCompanyModal from "../../components/Composables/AddCompany";
import DeleteConfirmationDialog from "../../components/Composables/DeleteDialogs";
import CustomSnackbar from "../../components/Composables/CustomSnackBarMenu";

export default function BranchDetails() {
  const [branchDetails, setBranchDetails] = useState({
    basicDetails: {},
    otherDetails: {},
  });
  const [open, setOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [backbutton, setbackbutton] = useState(false);
  const [selectedTab, setSelectedTab] = useState("BranchInfo");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "error",
  });
  const [branchBasicDetails, setBranchBasicDetails] = useState({});

  const navigate = useNavigate();
  const { id: branchId } = useParams();
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const getBranchDetails = async () => {
    try {
      const response = await API.get(`/company/branch-details/${branchId}`);
      if (response?.data?.success) {
        setBranchDetails({
          basicDetails: response.data.data["Basic Details"] || {},
          otherDetails: response.data.data["Other Details"] || {},
        });
        setBranchBasicDetails({
          Name: response.data.data["Basic Details"].Name || "",
          State: response.data.data["Basic Details"].State || "",
          City: response.data.data["Basic Details"].City || "",
          "Contact Number":
            response.data.data["Basic Details"]["Contact Number"] || "",
          Address:
            `${response.data.data["Basic Details"].Address}, ${response.data.data["Basic Details"].City}, ${response.data.data["Basic Details"].State}, ${response.data.data["Other Details"].ZIP}` ||
            "",
          "Additional Info":
            response.data.data["Basic Details"]["Additional Info"] || "",
        });
      }
    } catch (error) {
      console.error("Error fetching branch details ", error);
    }
  };

  useEffect(() => {
    getBranchDetails();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleDialog = () => {
    setOpenDialog(true);
  };

  const deleteCompanyFunction = async () => {
    try {
      const response = await API.post(
        `/company/delete-company-branch/${branchId}`
      );
      if (response?.data?.success) {
        setSnackbar({
          open: true,
          message: "Company branch deleted successfully",
          severity: "success",
        });
        setTimeout(() => {
          handleClose();
          navigate(-1);
        }, 2000);
      }
    } catch (error) {
      console.error("Error deleting company:", error);
      setSnackbar({
        open: true,
        message: "Error deleting company",
        severity: "error",
      });
    }
  };

  const handleDeleteConfirmation = async (confirmed) => {
    setOpenDialog(false);
    if (confirmed) {
      try {
        await deleteCompanyFunction();
      } catch (error) {
        console.error("Error deleting company:", error);
      }
    }
  };

  return (
    <Box
      sx={{
        padding: "16px",
        backgroundColor: "#E3F2FD",
        height: "100%",
        borderRadius: "24px 0 0 0",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#FFF",
          padding: "16px",
          borderRadius: "12px",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            borderBottom: "1px solid rgba(21, 29, 72, 0.12)",
            paddingBottom: "16px",
            // marginBottom: "20px",
            gap: "12px",
            alignItems: "center",
          }}
        >
          <Button
            startIcon={
              <ChevronLeftOutlinedIcon
                style={{ height: "16px", width: "16px" }}
              />
            }
            sx={{
              "& .MuiButton-startIcon": backbutton
                ? { marginRight: "4px !important" }
                : { margin: "0px" },
            }}
            style={
              backbutton
                ? {
                    backgroundColor: "#3F95EA",
                    color: "white",
                    height: "24px",
                    fontSize: "12px",
                    textTransform: "none",
                  }
                : {
                    backgroundColor: "#E7E7E7",
                    color: "#1A1A1A",
                    minWidth: "24px",
                    height: "24px",
                    padding: "4px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }
            }
            onMouseEnter={() => setbackbutton(true)}
            onMouseLeave={() => setbackbutton(false)}
            onClick={() => navigate(-1)}
          >
            {backbutton ? "Back" : ""}
          </Button>
          <Typography sx={{ fontSize: "22px", fontWeight: 600 }}>
            Branch Details
          </Typography>
        </Box>

        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Box sx={{ display: "flex", gap: "16px", alignItems: "center" }}>
            <Box
              sx={{
                width: "100px",
                height: "100px",
                backgroundColor: "#E3F2FD",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {branchDetails?.otherDetails?.logo ? (
                <img
                  src={`${process.env.REACT_APP_BASEURL}${branchDetails?.otherDetails?.logo}`}
                  alt="Company Logo"
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "contain",
                    borderRadius: "8px",
                  }}
                />
              ) : (
                <ApartmentIcon sx={{ fontSize: "100px", color: "#979797" }} />
              )}
            </Box>

            <Box>
              <Box sx={{ display: "flex", gap: "8px", alignItems: "center" }}>
                <Typography fontSize={"20px"} fontWeight={600}>
                  {branchDetails.basicDetails.Name}
                </Typography>
                {branchDetails.otherDetails["Is Default"] > 0 && (
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontWeight: "500",
                      padding: "0.25rem 0.5rem",
                      border: "1px solid #99C4E2",
                      borderRadius: "0.25rem",
                      color: "#006CB7",
                    }}
                  >
                    Default
                  </Typography>
                )}
              </Box>

              <Typography sx={{ fontSize: "14px", color: "#00000099" }}>
                {branchDetails.basicDetails.City},{" "}
                {branchDetails.basicDetails.State}
              </Typography>
            </Box>
          </Box>
          <Box>
            <Button
              variant="outlined"
              sx={{ marginRight: "16px" }}
              startIcon={<ModeEditIcon />}
              onClick={handleOpen}
            >
              Edit
            </Button>
            <Button
              startIcon={<DeleteOutlineOutlinedIcon />}
              variant="outlined"
              color="error"
              sx={{ alignSelf: "flex-start" }}
              disabled={branchDetails.otherDetails["Is Default"] > 0}
              onClick={handleDialog}
            >
              <Typography sx={{ fontSize: "12px", fontWeight: "400" }}>
                DELETE
              </Typography>
            </Button>
          </Box>
        </Box>

        {/* Tabs */}
        <Tabs
          value={selectedTab}
          onChange={(e, newValue) => setSelectedTab(newValue)}
          sx={{
            borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
            // margin: "20px 0",
          }}
        >
          <Tab
            value="BranchInfo"
            label="Branch Info"
            sx={{ fontWeight: "500", fontSize: "14px" }}
          />
        </Tabs>

        {selectedTab === "BranchInfo" && (
          <Box
            sx={{
              display: "flex",
              width: "100%",
              gap: "20px",
              height: "calc(100% - 250px)",
            }}
          >
            {/* Basic Information */}
            <Card
              elevation={0}
              sx={{
                borderRadius: "4px",
                border: "1px solid rgba(115, 119, 145, 0.08)",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                maxHeight: "100%",
                overflow: "hidden",
              }}
            >
              <Box
                sx={{
                  borderRadius: "4px 4px 0 0",
                  padding: "14px 20px",
                  backgroundColor: "rgba(63, 149, 234, 0.20)",
                  fontSize: "14px",
                  fontWeight: "600",
                  flexShrink: 0,
                }}
              >
                Basic Details
              </Box>
              <CardContent
                sx={{ padding: "16px 20px", flexGrow: 1, overflowY: "auto" }}
              >
                {Object.entries(branchBasicDetails).map(([key, value]) => (
                  <Box
                    key={key}
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      flexWrap: "wrap",
                      marginBottom: "8px",
                    }}
                  >
                    <Typography
                      sx={{
                        textTransform: "capitalize",
                        fontWeight: "400",
                        fontSize: "14px",
                        color: "rgba(0, 0, 0, 0.60)",
                        minWidth: "160px",
                        maxWidth: "160px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {key}
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: "400",
                        fontSize: "14px",
                        color: "rgba(0, 0, 0, 0.87)",
                        flex: 1,
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                      }}
                      dangerouslySetInnerHTML={{
                        __html: value
                          ? key === "Created On"
                            ? dayjs(value).format("DD/MM/YYYY")
                            : value
                          : "NA",
                      }}
                    ></Typography>
                  </Box>
                ))}
              </CardContent>
            </Card>

            {/* Recent Activities */}
            {/* <Card
              elevation={0}
              sx={{
                borderRadius: "4px",
                border: "1px solid rgba(115, 119, 145, 0.08)",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                maxHeight: "100%",
                overflow: "hidden",
              }}
            >
              <Box
                sx={{
                  borderRadius: "4px 4px 0 0",
                  padding: "12px 20px",
                  backgroundColor: "rgba(63, 149, 234, 0.20)",
                  fontSize: "14px",
                  fontWeight: "600",
                  display: "flex",
                  flexShrink: 0,
                  justifyContent: "space-between",
                }}
              >
                Recent Activities
              </Box>
              <CardContent
                sx={{
                  padding: "16px 20px",
                  flexGrow: 1,
                  overflowY: "auto",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  color="text.secondary"
                >
                  No recent activities
                </Typography>{" "}
              </CardContent>
            </Card> */}
          </Box>
        )}
      </Box>
      <AddCompanyModal
        open={open}
        handleClose={handleClose}
        branchId={branchId}
        branchDetails={branchDetails}
      />
      <DeleteConfirmationDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        onConfirm={handleDeleteConfirmation}
        pageName={"branch"}
      />
      <CustomSnackbar
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      />
    </Box>
  );
}
